import React from 'react';
import { bool, string } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import NamedLink from '../NamedLink/NamedLink';

import css from './BlockUser.module.css';

/**
 * The neutral text shown where a contact action used to be, when two users blocked each
 * other (P25028-272). It never says who blocked whom (AC10).
 *
 * `inConversation` shows the longer text used in place of the message box, with the
 * link to Causee support. Support is the Contact Us page, as for "Report listing".
 */
const ContactBlockedNotice = props => {
  const { className, inConversation } = props;

  return (
    <p className={classNames(css.notice, className)} role="status">
      {inConversation ? (
        <FormattedMessage
          id="BlockUser.conversationNotice"
          values={{
            link: chunks => (
              <NamedLink className={css.noticeLink} name="CMSPage" params={{ pageId: 'contact' }}>
                {chunks}
              </NamedLink>
            ),
          }}
        />
      ) : (
        <FormattedMessage id="BlockUser.cannotContact" />
      )}
    </p>
  );
};

ContactBlockedNotice.defaultProps = {
  className: null,
  inConversation: false,
};

ContactBlockedNotice.propTypes = {
  className: string,
  inConversation: bool,
};

export default ContactBlockedNotice;
